import script from "./BrushMapReports.vue?vue&type=script&lang=ts&setup=true"
export * from "./BrushMapReports.vue?vue&type=script&lang=ts&setup=true"

import "./BrushMapReports.vue?vue&type=style&index=0&id=1355c751&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1355c751"]])

export default __exports__